import { Avatar, Card, Icon, Space, Typography } from '@sravni/react-design-system';
import { Bank } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import styles from './OfferPreviewCard.module.scss';

interface OfferPreviewCardProps {
  title: string;
  subtitle: string;
  logo: string;
  details: Array<{ label: string; value: string }>;
  button: React.ReactNode;
  containerProps?: React.ComponentProps<typeof Space>;
  detailsProps?: React.ComponentProps<typeof Space>;
}

export const OfferPreviewCard = ({
  title,
  subtitle,
  logo,
  details,
  button,
  containerProps = {},
  detailsProps = {},
}: OfferPreviewCardProps) => {
  const isMobile = useIsMobile();

  const ButtonComponent = <Space className={styles.button}>{button}</Space>;

  return (
    <Space direction="vertical">
      <Card
        size={16}
        className={cn(styles.card)}
      >
        <Space
          direction="vertical"
          size={16}
        >
          <Space
            size={isMobile ? 12 : 16}
            direction={isMobile ? 'vertical' : 'horizontal'}
            {...containerProps}
          >
            <Space
              size={16}
              align="center"
            >
              {logo ? (
                <Avatar
                  className={styles.avatar}
                  size={36}
                  src={logo}
                />
              ) : (
                <Icon
                  size={28}
                  icon={<Bank />}
                />
              )}

              <Space
                size={2}
                direction="vertical"
              >
                <Typography.Heading level={4}>{title}</Typography.Heading>

                <Typography.Text size={14}>{subtitle}</Typography.Text>
              </Space>

              {isMobile ? ButtonComponent : null}
            </Space>

            <Space
              size={24}
              align="center"
            >
              <Space
                size={isMobile ? 8 : 16}
                justify="end"
                {...detailsProps}
              >
                {details.map((detail) => {
                  return (
                    <Space
                      className={styles.summary}
                      size={2}
                      direction="vertical"
                      key={detail.label}
                    >
                      <Typography.Text
                        className={cn(styles.noWrap, 'h-color-D60')}
                        size={12}
                      >
                        {detail.label}
                      </Typography.Text>

                      <Typography.Text
                        className={styles.noWrap}
                        strong
                        size={16}
                      >
                        {detail.value}
                      </Typography.Text>
                    </Space>
                  );
                })}
              </Space>

              {isMobile ? null : ButtonComponent}
            </Space>
          </Space>
        </Space>
      </Card>
    </Space>
  );
};
